import React from 'react';
import { MOCK_UP } from '../../../propTypes';
import { Composition } from '../Composition';
import { wideMockUp, squareMockUp } from './config';

export const CardsMockUp = ({ variation, className, isSquare = false }) => {
    const mockup = isSquare ? squareMockUp : wideMockUp;

    return (
        <Composition
            className={className}
            variation={variation}
            layers={mockup.layers}
            aspectRatio={mockup.aspectRatio}
            transparentBackground={true}
        />
    );
};

CardsMockUp.propTypes = MOCK_UP;
